import { AccordionDetails, AccordionDetailsProps } from '@mui/material'
import { styled } from '@mui/system'

export const ContentAccordionDetails = styled(
  (props: AccordionDetailsProps & { isSmallScreen: boolean }) => (
    <AccordionDetails {...props} />
  )
)(({ isSmallScreen }) => ({
  padding: isSmallScreen ? '0px 4px 20px' : '0px 4px 24px',
  '& ul': {
    margin: 0,
    paddingInlineStart: isSmallScreen ? '32px' : '40px'
  },
  '& li': {
    fontSize: isSmallScreen ? '14px' : '20px',
    lineHeight: '180%'
  },
  '& p': {
    fontSize: isSmallScreen ? '16px' : '22px',
    lineHeight: '150%',
    paddingInline: isSmallScreen ? '32px' : '40px',
    marginTop: 0
  }
}))
